import { searchStringToParams } from 'lib-shared-url';
import { Navigate, useLocation } from 'react-router-dom';

import { createSearchUrl } from 'app/views/layout/views/search/utils';

import { transformLegacyConversationsParamsToSearchApiArg } from './utils/transformLegacyConversationsParamsToSearchApiArg';

/**
 * Redirects from the legacy `/conversations` route to `/search/conversations`,
 * translating conversations query parameters to search equivalents.
 */
export const LegacyConversationsRedirectToSearch = (): JSX.Element => {
  const location = useLocation();
  const params = searchStringToParams(location.search);

  const { filters, sortBy, page } =
    transformLegacyConversationsParamsToSearchApiArg(params, {
      enrichStatus: false,
    });

  const url = createSearchUrl({
    query: '',
    filters: filters ?? { strategy: 'all', filters: [] },
    sortBy,
    page,
    isStrict: false,
  });

  return <Navigate to={url} replace />;
};
